import React from 'react'
import 'react-datalist-input/dist/styles.css';
import Clientrep from './Clientrep';


const HomeScreen = () => {
 
  return (
    
    <div>

    <Clientrep />
    </div>
  )
  }
  

export default HomeScreen ;









